export async function hashObject(obj: any) {
  // Convert the object to a JSON string
  const str = JSON.stringify(obj);

  // Encode the string as bytes
  const bytes = new TextEncoder().encode(str);
  // Create an ArrayBuffer view to satisfy BufferSource strictly
  const data = bytes.buffer.slice(bytes.byteOffset, bytes.byteOffset + bytes.byteLength);
  const view = new DataView(data as ArrayBuffer);

  // Compute the hash
  const hashBuffer = await crypto.subtle.digest('SHA-256', view);

  // Convert the hash to a hexadecimal string
  return Array.from(new Uint8Array(hashBuffer))
    .map((b) => b.toString(16).padStart(2, '0'))
    .join('');
}
